import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';

const PdfAcompanhamentoAOPME = ({ title, list, theme }) => {
  const componentRef = useRef();
  const textIcon = (theme === 'dark' ? '_dark' : ''); 

  const handlePrint = useReactToPrint({
    documentTitle: 'Relatório de Acompanhamento OPME',
    content: () => componentRef.current,
  });

  return (
    <>
      <button className={'buttonIcon '+theme}><img src={"/img/icon_printer"+textIcon+".svg"} alt="" onClick={handlePrint} /></button>
      <div style={{ display: 'none' }}>
        <div ref={componentRef} style={{ width: '100%', height: window.innerHeight }}>
          <div className='inforow' style={{marginTop: '40px',marginLeft: '80px', marginRight: '80px'}}>
            <div className="inforow right">
              <h3 style={{fontSize: '18px'}}>{title}</h3 >
            </div>
            <div className="inforow left">
              <img src="/img/logo_powered_insightcare.png" alt="Insightcare" style={{width: '12vw', position:'relative', marginLeft: '32px', float: 'right'}}/>
              <img src="/img/logo_gruposanta.png" alt="Gruposanta" style={{width: '12vw', position:'relative', float: 'right', marginLeft: '25px'}}/>
            </div>
          </div>
          <div className="inforow" style={{marginLeft: '80px', marginRight: '80px'}}>
            <div className='inforow right'>
              <div className='infoText' style={{fontSize: '12px'}}>Mostrando {list.length} pacientes </div>
            </div>
            <div className='inforow left'>
              <div className='infoText' style={{fontSize: '12px'}}>Impresso em {moment().format('HH:mm, [dia] D [de] MMMM [de] YYYY')}</div>
            </div>
          </div>
          <div className='tablePDF'>
            <table>
              <thead>
                <tr>
                <th>Convênio</th>
                <th>Caráter</th>
                <th>Paciente</th>
                <th>Cirurgião </th>
                <th>OPME Sem Autorização</th>
                <th>Aviso Cirúrgico</th>
                <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {list.map((data) => {
                  let color = '';
                  let statusClass = "ready";
                  let tdClassFarm = "";
                  let spanClassFarm = "";
                  let name = data.Paciente.split(' ').slice(-1).join(' ') + ', ' + data.Paciente.split(' ')[0].slice(0, 1);
                  let carater = data.TipoCirurgia === 'Eletiva' ? 'E' : (data.TipoCirurgia === 'Urgência' ? 'U' :'');
                  let autorizacaoOPME = data.BoolOPMESemAutorizacao === 1 ? 'SIM' : 'NÃO';
                  let key = "tr-" + data.ID;

                  if (data.Status === 'Agendada') {
                    statusClass = 'scheduled';
                  } else if (data.Status === 'Realizada') {
                    statusClass = "ready";
                  } else if (data.Status === 'Cancelada') {
                    statusClass = 'canceled';
                  } else {
                    statusClass = "progress";
                  }

                  return (
                    <tr key={key} className={statusClass}>
                    <td style={{ color: color , overflowWrap: 'break-word', wordWrap: 'break-word'}} align="left">{data.Convenio}</td>
                    <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left">{carater}</td>
                    <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left"><b>{name}</b> </td>
                    <td style={{ overflow: 'hidden', whiteSpace: 'nowrap' }} align="left">{data.Responsavel}</td>
                    <td className={tdClassFarm} align="left"><span className={spanClassFarm}></span>{autorizacaoOPME}</td>
                    <td className={tdClassFarm} align="left"><span className={spanClassFarm}></span>{data.Codigo}</td>
                    <td style={{ color: color }} align="left">{data.Status}</td>  
                    </tr>
                  )
                })
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default PdfAcompanhamentoAOPME;